<!-- 上传视频组件 -->
<template>
	<div>
		<el-upload class="upload-demo" :action="action" :before-upload="beforeUpload" :on-preview="handlePreview"
			:on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed"
			:file-list="fileList" :data="data" :on-success="handleAvatarSuccess" :on-change="handleLimit">
			<el-button size="small" type="primary" v-show="is_show_upload">点击上传</el-button>
			<div slot="tip" class="el-upload__tip">只能上传mp4等文件，且不超过{{max_video_size}}mb</div>
		</el-upload>
	</div>
</template>

<script>
	import {
		getToken,
	} from '@/tool/cookie'
	export default {
		data() {
			return {
				action: process.env.VUE_APP_ADMIN_BASE_URL + '/Task/uploadVideo',
				fileList: [],
				data: {
					'login_uid': '',
					'token': '',
				},
				is_show_upload:true,
			};
		},
		props: { // 定义组件的属性
			video_num: { // 限制上传的视频数量
				type: Number,
				default: 1,
			},
			index: { // 父组件的索引
				type: Number,
				default: 0,
			},
			video_url:{ // 定义默认的视频列表
				type:Array|String,
				default:[],
			},
			max_video_size:{ // 评语最大视频大小
				type: Number,
				default: 10,
			}
		},
		created() {
			this.data.login_uid = getToken('login_uid');
			this.data.token = getToken('token');
		},
		watch:{
			video_url(){ // 监听video_url的变化
				this.resetVideoUrl()
			}
		},
		methods: {
			resetVideoUrl(){
				this.fileList = this.video_url;
				if(this.fileList == ''){
					this.fileList = [];
				}
				this.videoNumCheck(this.video_url.length)
			},
			beforeUpload(file) { // 上传之前的操作
				if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
					this.$message.error('请上传正确的视频格式');
					return false;
				}
				
				let max_size = (file.size / 1024 / 1024) < this.max_video_size;
				if(!max_size){
					this.$message.error('视频大小不能超过'+this.max_video_size+'M');
					return false;
				}
				
				return true;
			},
			handleRemove(file, fileList) {
				this.videoNumCheck(fileList.length)
				this.$emit("videoList", fileList, this.index);
			},
			handlePreview() {

			},
			beforeRemove() {},
			handleExceed() {

			},
			handleAvatarSuccess(res, file, file_list) { // 上传成功的操作
				file.url = file.response.key;
				this.$emit("videoList", file_list, this.index);
			},
			handleLimit(file, fileList) { //限制视频个数，文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
				this.videoNumCheck(fileList.length)
			},
			videoNumCheck(length) { // 判断视频的个数，用来显示和隐藏
				if (length >= this.video_num) {
					this.is_show_upload = false;
				} else {
					this.is_show_upload = true;
				}
			}
		}
	}
</script>

<style>
</style>
